export default class SectorsFilter {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.textSearch = "";
  }
  fillData(data) {
    this.textSearch = data.textSearch;
  }
}
